import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { parseMoananiDateTime, PERU_IANA } from '../../core/utils/peru-datetime';

@Pipe({ name: 'peruDate', standalone: true })
export class PeruDatePipe implements PipeTransform {
  private readonly datePipe = new DatePipe('es-PE');

  transform(
    value: string | Date | number | null | undefined,
    format: string = 'dd/MM/yyyy HH:mm'
  ): string | null {
    const d = parseMoananiDateTime(value);
    if (!d) return null;
    return this.datePipe.transform(d, format, PERU_IANA, 'es-PE');
  }
}
